import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';
import * as mutationType from './mutationTypes';

Vue.use(Vuex);

const state = {
  auth: {
    logged: false,
    user: null,
    redirect: null,
  },
  user: {},
  plans: [],
  devices: [],
  tickets: [],
};

const mutations = {
  [mutationType.LOGIN_USER](state, userData, redirect) {
    state.auth.logged = true;
    state.auth.user = userData;
    state.auth.redirect = redirect;
  },
  [mutationType.UPDATE_USER](state, userData) {
    state.auth.user = Object.assign(state.auth.user, userData);
  },
  [mutationType.LOGOUT_USER](state) {
    state.auth.logged = false;
    state.auth.user = {};
    state.auth.plans = [];
    state.auth.devices = [];
    state.auth.tickets = [];
  },
  [mutationType.USER_PROFILE](state, user) {
    state.user = user;
  },
  [mutationType.USER_PLANS](state, plans) {
    state.plans = plans;
  },
  [mutationType.USER_DEVICES](state, devices) {
    state.devices = devices;
  },
  [mutationType.USER_TICKETS](state, tickets) {
    state.tickets = tickets;
  },
};

const getters = {
  beUser: state => state.auth.user,
  isLogged: state => state.auth.logged,
  hasSentinel: state => state.plans.some(p => p.plan.has_sentinel),
  isAdmin: state => state.user.is_admin,
  isProfileConfirmed: state => state.auth.user && state.auth.user.extra ? state.auth.user.extra.profile_confirmed : false,
};

const actions = {
  async loginByUsernamePassword(context, logindata, redirect) {
    const session = await this._vm.$apiclient.loginWithUsernamePassword(logindata);
    context.commit(mutationType.LOGIN_USER, session, redirect);
  },
  async logout(context) {
    context.commit(mutationType.LOGOUT_USER);
  },
  async getProfile(context) {
    const data = await this._vm.$apiclient.getProfile();
    context.commit(mutationType.USER_PROFILE, data);
  },
  async getPlans(context) {
    const data = await this._vm.$apiclient.getPlans();
    context.commit(mutationType.USER_PLANS, data.plans);
  },
  async getDevices(context) {
    const data = await this._vm.$apiclient.getDevices();
    context.commit(mutationType.USER_DEVICES, data);
  },
  async getTickets(context) {
    const data = await this._vm.$apiclient.getTickets();
    context.commit(mutationType.USER_TICKETS, data);
  },
};

export default new Vuex.Store({
  state,
  actions,
  mutations,
  getters,
  plugins: [createPersistedState()],
});



// WEBPACK FOOTER //
// ./src/store/index.js